"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Location {
    constructor() {
        this.lat = 0;
        this.long = 0;
    }
    /**
     * @function getScheme: Returns the scheme to set a destination
     * @Return {Navigation} Object with Latitude and Longitude
     */
    get scheme() {
        return {
            scheme: `com.toyota.navi://setDestination?lon=${this.longitude}&lat=${this.latitude}`,
        };
    }
    /**
     * @function latitude: Set the value of the latitude
     * @Return {void}
     */
    set latitude(value) {
        this.lat = value;
    }
    /**
     * @function latitude: Get the value of the latitude
     * @Return {number}
     */
    get latitude() {
        return this.lat;
    }
    /**
     * @function longitude: Get the value of the longitude
     * @Return {number}
     */
    get longitude() {
        return this.long;
    }
    /**
     * @function longitude: Set the value of the longitude
     * @Return {void}
     */
    set longitude(value) {
        this.long = value;
    }
}
exports.default = Location;
//# sourceMappingURL=location.js.map